import { render, staticRenderFns } from "./ChangeMassEmailStatus.vue?vue&type=template&id=436bdfae&scoped=true&"
import script from "./ChangeMassEmailStatus.vue?vue&type=script&lang=js&"
export * from "./ChangeMassEmailStatus.vue?vue&type=script&lang=js&"
import style0 from "./ChangeMassEmailStatus.vue?vue&type=style&index=0&id=436bdfae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436bdfae",
  null
  
)

export default component.exports